import React from 'react';
import PropTypes from 'prop-types';
import NumberWeightSummary from 'components/app/crm/reports/components/NumberWeightSummary';

// Four headline KPIs reusing the legacy NumberWeightSummary card (vs <prev> / %↑↓
// / View Detail). Mapped only to fields that carry a previous-year value.
const OverviewKpiCards = ({ data, onDrill }) => {
  const jobEntry = data?.job_entry || {};
  const contract = data?.contract || {};
  const sales    = data?.sales || {};

  return (
    <div className="tw-grid tw-grid-cols-12 tw-gap-3 tw-mb-3">
      <div className="tw-col-span-12 sm:tw-col-span-6 md:tw-col-span-3">
        <NumberWeightSummary
          title="Total PCV"
          current_value={Number(sales.total_projects) || 0}
          previous_value={Number(sales.prev_total_projects) || 0}
          isRevenue={false}
          handleClick={() => onDrill({ section: 'pcv', title: 'Total PCV — Projects' })}
          titleHeader="Total projects (PCV) created in the selected period (vs same period last year)"
        />
      </div>
      <div className="tw-col-span-12 sm:tw-col-span-6 md:tw-col-span-3">
        <NumberWeightSummary
          title="Weight of Jobs (M.T)"
          current_value={Number(jobEntry.total_weight) || 0}
          previous_value={Number(jobEntry.prev_total_weight) || 0}
          isRevenue
          handleClick={() => onDrill({ section: 'job_entry', title: 'Job Entry — Records' })}
          titleHeader="Total job weight in the selected period"
        />
      </div>
      <div className="tw-col-span-12 sm:tw-col-span-6 md:tw-col-span-3">
        <NumberWeightSummary
          title="Signed Contract (USD)"
          current_value={Number(contract.grand_total_value) || 0}
          previous_value={Number(contract.yoy?.prev_total_value) || 0}
          isRevenue
          handleClick={() => onDrill({ section: 'contract', title: 'Signed Contracts' })}
          titleHeader="Signed contract value (incl. addendums) in the selected period"
        />
      </div>
      <div className="tw-col-span-12 sm:tw-col-span-6 md:tw-col-span-3">
        <NumberWeightSummary
          title="Sales Pipeline (USD)"
          current_value={Number(sales.pipeline_value) || 0}
          previous_value={Number(sales.prev_pipeline_value) || 0}
          isRevenue={false}
          handleClick={() => onDrill({ section: 'sales', title: 'Sales Pipeline — Projects' })}
          titleHeader="Active pipeline value in the selected period"
        />
      </div>
    </div>
  );
};

OverviewKpiCards.propTypes = {
  data: PropTypes.object,
  onDrill: PropTypes.func.isRequired
};

export default OverviewKpiCards;
